import React, { useContext } from 'react';
import Office from '../../../layouts/office/Office/Office';
import OfficeView from '../../../views/office/OfficeView/OfficeView';
import T, { t } from '../../../common/components/T';
import { getLangPaths, getUserStaticProps } from '../../api/_props';
import { UserProfileContext } from '../../../common/utils/getContext';

const OfficeDefault = ({ translates }) => {
    const { profileData } = useContext(UserProfileContext);
    const breadcrumbs = [
        {
            title: t('mainPageTitle', 'Главная', 'all', translates),
            link: '/'
        },
        {
            title: t('officeTitle', 'Кабинет', 'all', translates),
            link: '/office'
        }
    ];
    return (
        <Office
            title={t('officeTitle', 'Кабинет', 'all', translates)}
            translates={translates}
            breadcrumbs={breadcrumbs}
            active='/office'
            titleBlock={{
                title: profileData?.first_name ? (
                    <T
                        vars={{ name: profileData?.first_name }}
                        textName='officeNewTitleWithName'
                        defaultStr='Приветствуем вас, ${name}!'
                        page='/office'
                    />
                ) : (
                    <T textName='officeNewTitle' defaultStr='Приветствуем вас!' page='/office' />
                ),
                text: (
                    <T
                        textName='officeUndetitle'
                        defaultStr='Давайте сделаем этот день продуктивным вместе с Global Trend'
                        page='/office'
                    />
                )
            }}
        >
            <OfficeView />
        </Office>
    );
};

export async function getStaticProps({ params }) {
    return await getUserStaticProps(params, '/office', ['/office'], 'office');
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}
export default OfficeDefault;
